module.exports = __webpack_public_path__ + "static/media/twinkle-color-carousel-2.d4806c1e.png";